(function () {
    'use strict';

    angular
        .module('oddModule')
        .controller('ODDExternalPartyFullController', Controller);

    Controller.$inject = ['$scope', 'oddService', '$state','$timeout', 'govNotificationDelay', 'notificationService'];

    function Controller($scope, oddService, $state, $timeout, govNotificationDelay, notificationService) {
        $scope.ctxtCtrl = {};

        // === Actions ===

        $scope.createOrUpdate = function() {
            if ($scope.form.$invalid) {
                showFormError();
                return;
            }
            $scope.ctxtCtrl.isLoading = true;
            $scope.ctxtCtrl.isFormInvalidMsgShow = false;

            if (!$scope.boxModel.ODDExternalPartyID) {
                return createExternalParty();
            }
            return updateExternalParty();
        };

        function createExternalParty() {
            oddService.createExternalParty($scope.boxContext.BusinessUnit.ODDBusinessUnitID, $scope.boxModel)
                .then(function (updatedExternalParty) {
                    notificationService.notify('The Partner was created');
                    $scope.form.$setPristine();

                    $scope.boxContext.BusinessUnit.ODDExternalParties.push(updatedExternalParty);
                    $state.go('odd.externalPartyEdit', { ODDExternalPartyID: updatedExternalParty.ODDExternalPartyID });
                }).finally(function() {
                    $scope.ctxtCtrl.isLoading = false;
                });
        }

        function updateExternalParty() {
            oddService.updateExternalParty($scope.boxContext.BusinessUnit.ODDBusinessUnitID, $scope.boxModel)
                .then(function (updatedExternalParty) {
                    // Update current
                    $scope.boxModel = updatedExternalParty;

                    notificationService.notify('Your changes have been saved');
                    $scope.form.$setPristine();
                }).finally(function() {
                    $scope.ctxtCtrl.isLoading = false;
                });
        }

        // Reset form
        $scope.reset = function () {
            $state.reload();
        };

        // Cancel
        $scope.cancel = function () {
            $state.go($state.$current.parent.name, { reload: true });
        };

        function showFormError() {
            $scope.ctxtCtrl.showSubmitError = true;
            $scope.ctxtCtrl.isFormInvalidMsgShow = true;
            $timeout(function () {
                $scope.ctxtCtrl.isFormInvalidMsgShow = false;
            }, govNotificationDelay);
        }
    }
})();